import { ApiUser } from './getUser'

type User = Pick<ApiUser, 'mfa_required'>;

export function mustHaveMFA(user: User) {
    if (process.env.REACT_APP_DISABLE_MFA === 'true') {
        return false
    }

    return  user.mfa_required
}
